<template>
  <component :is="lazyComponent">
    {{ title ? title : icon }}
  </component>
</template>

<script>
export default {
  name: 'SvgWrapper',

  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      lazyComponent: null,
    };
  },

  mounted() {
    this.loadComponent();
  },

  methods: {
    loadComponent() {
      import(`./elements/Icon${this.icon}.vue`).then((component) => {
        this.lazyComponent = component.default;
      });
    },
  },
};
</script>
